
import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header'; // Dein normaler Header
import './Menu.css';
// Bilder aus public/assets/ nutzen (KEIN import nötig!):
const menuImage = '/assets/speisekarte_break.webp';
const menuImage2 = '/assets/speisekarte_abend.webp';


const Menu: React.FC = () => {
    return (
        <div className="menu-page-wrapper">
            {/* 1. Mobile Back-Button (Nur auf Handys sichtbar) */}
            <div className="mobile-back-bar">
                <Link to="/" className="back-button" aria-label="Zurück">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"
                         strokeLinecap="round" strokeLinejoin="round">
                        <path d="M19 12H5M12 19l-7-7 7-7"/>
                    </svg>
                </Link>
            </div>

            {/* 2. Standard Header (Wird auf Mobile für diese Seite angepasst/ausgeblendet) */}
            <div className="desktop-header-wrapper">
                <Header/>
            </div>

            {/* Hauptinhalt */}
            <main className="menu-content-container">
                <header className="menu-header">
                    <h2>THE MENU</h2>
                </header>

                <div className="menu-image-container">
                    <img
                        src={menuImage}
                        alt="Lilith Restaurant Speisekarte"
                        className="menu-jpg"
                    />
                </div>
                <div className="menu-image-container">
                    <img
                        src={menuImage2}
                        alt="Lilith Restaurant Speisekarte"
                        className="menu-jpg"
                    />
                </div>
            </main>
        </div>
    );
};

export default Menu;